import React, { forwardRef } from "react";

// Simple wrapper around a styled <button>, keeping layout responsibilities outside.
// For measurement and focus control, we forward the ref to the underlying <button>.
const ButtonBtn = forwardRef(
  (
    {
      className,
      children,
      marginBlock = "10px",
      centered = false, // kept for backward-compat; use justifyContent instead
      justifyContent = "flex-end",
      as,
      href,
      disabled,
      onClick,
      hoverBg, // custom background color on :hover/:focus (optional)
      hoverColor, // custom text color on :hover/:focus (optional)
      style, // allow passing inline styles; we'll merge CSS vars in
      ...props
    },
    ref
  ) => {
    const isLink = as === "a" || typeof href === "string";
    const Element = isLink ? "a" : "button";

    // Prepare CSS variable overrides for hover/active states
    const varStyles = {
      ...(hoverBg
        ? { "--btn-hover-bg": hoverBg, "--btn-hover-border": hoverBg }
        : {}),
      ...(hoverColor ? { "--btn-hover-color": hoverColor } : {}),
      // Active state uses hover values via CSS fallbacks
    };

    const commonProps = {
      ref,
      className: `btn ${className || ""}`,
      // Merge our CSS var styles first, allow consumer style to override
      style: { ...varStyles, ...(style || {}) },
      ...(isLink ? { href } : {}),
      ...(disabled
        ? isLink
          ? { "aria-disabled": true, onClick: (e) => e.preventDefault() }
          : { disabled: true }
        : {}),
      ...props,
    };

    // Prefer consumer-provided onClick when not disabled; prevent default when disabled link
    if (onClick && !(disabled && isLink)) {
      commonProps.onClick = onClick;
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: justifyContent,
          marginBlock: marginBlock,
        }}
      >
        <Element {...commonProps}>{children || "Tlačítko"}</Element>
      </div>
    );
  }
);

export default ButtonBtn;
